// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gateway-create-gateway-create-76106 .gateway-create-steps-wrapper-7fcb1{align-items:center;display:flex;height:72px;justify-content:center}.gateway-create-gateway-create-76106 .gateway-create-steps-wrapper-7fcb1 .gateway-create-steps-20281{width:800px}.gateway-create-gateway-create-76106 .gateway-create-form-wrapper-228ba{background-color:#fff;border-radius:6px;margin:0 auto;padding:24px;width:1180px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gateway-create": "gateway-create-gateway-create-76106",
	"gatewayCreate": "gateway-create-gateway-create-76106",
	"steps-wrapper": "gateway-create-steps-wrapper-7fcb1",
	"stepsWrapper": "gateway-create-steps-wrapper-7fcb1",
	"steps": "gateway-create-steps-20281",
	"form-wrapper": "gateway-create-form-wrapper-228ba",
	"formWrapper": "gateway-create-form-wrapper-228ba"
};
export default ___CSS_LOADER_EXPORT___;
